import {post, get} from './utils';

const dao = {
  listReport: async params => {
    const r = await post('/smb-backend/webmodule/list-report.action', params);
    return {
      ...r,
      valid: r && r.data,
      overall: {
        sinceTime: r.sinceTime,
        untilTime: r.untilTime,
        avgNewCount: r.avgNewCount,
        totalCount: r.totalCount,
      },
    };
  },
  listSkuPreference: params =>
    post('/smb-backend/webmodule/list-color-preference.action', params),
  queryUniqueUserUsage: () =>
    get('/smb-backend/webmodule/query-unique-user-usage.action'),
};

export default dao;
